import { Component, Vue } from 'vue-property-decorator';
import { Inject } from 'vue-di-container';
import WithRender from './PermissionManagement.html';
import UserManagementService from '../../UserManagement/UserManagementService';
import { Toaster } from '../../../Services/toast';
import PermissionManagementService from './PermissionManagementService';
import UserService from '@/shared/userService/UserService';
import UserRoleService from '@/shared/userService/UserRoleService';
import type { PermissionRow, ApiPermissionItem } from './permissions.types';
import { SCREEN_LABELS } from './PermissionsKeys';

@WithRender
@Component({
    diProvide: [UserManagementService, PermissionManagementService, UserService, UserRoleService],
})
export default class PermissionManagement extends Vue {
    @Inject(UserManagementService) public userManagementService!: UserManagementService;
    @Inject(PermissionManagementService) public permissionManagementService!: PermissionManagementService;
    @Inject(UserService) public userService!: UserService;
    @Inject(UserRoleService) public userRoleService!: UserRoleService;

    public userId: string = this.$route.params.id;
    public username: string = '';
    public rows: PermissionRow[] = [];
    public confirmDialog: boolean = false;
    public User: any;
    public userRole: number | undefined;
    public pagination: any = { rowsPerPage: -1 };

    public get headers(): any[] {
        return [
            { text: 'Permission', value: 'label', align: 'center', sortable: false },
            { text: 'Allow', value: 'allow', align: 'center', sortable: false, width: 120 },
        ];
    }


    public get saveDisabled(): boolean {
        return this.rows.every(r => r.allow === r.initial);
    }

    private sortRowsForDisplay(): void {
        this.rows = this.rows.slice().sort((a, b) => {
            if (a.allow !== b.allow) return a.allow ? -1 : 1;
            return a.label.localeCompare(b.label);
        });
    }

    public async mounted() {
        this.User = await this.userService.getUser();
        this.userRole = await this.userRoleService.GetUserRole(this.User);

        const user = await this.userManagementService.GeById(this.userId);
        if (user) {
            this.username = (user.username !== undefined && user.username !== null)
                ? user.username
                : (user.Username !== undefined && user.Username !== null)
                    ? user.Username
                    : '';
        }

        const res: any = await this.permissionManagementService.GetPermissions(this.userId);
        const ok = res && (res.isSuccess === true || res.IsSuccess === true);
        if (!ok) {
            const msg = res && (res.errorMessage || res.ErrorMessage)
                ? (res.errorMessage || res.ErrorMessage)
                : 'Failed to load permissions';
            Toaster.error(msg);
            return;
        }

        const list: ApiPermissionItem[] = (res.result || res.Result || []) as ApiPermissionItem[];

        this.rows = Object.keys(SCREEN_LABELS).map(k => {
            const found = list.find(x => (x.screenKey === k) || (x.ScreenKey === k));
            let allow = false;
            if (found) {
                if (typeof found.isAllowed === 'boolean') allow = found.isAllowed!;
                else if (typeof (found as any).IsAllowed === 'boolean') allow = (found as any).IsAllowed!;
            }
            return { key: k, label: SCREEN_LABELS[k], allow, initial: allow };
        });

        this.sortRowsForDisplay();
    }


    public onToggle(_row: PermissionRow) { }

    public confirmSave() {
        if (this.saveDisabled) return;
        this.confirmDialog = true;
    }

    public async save() {
        this.confirmDialog = false;

        for (const r of this.rows) {
            if (r.allow === r.initial) continue;
            const resp: any = await this.permissionManagementService.UpsertPermission(this.userId, r.key, r.allow);
            const ok = resp && (resp.isSuccess === true || resp.IsSuccess === true);
            if (!ok) {
                const msg = resp && (resp.errorMessage || resp.ErrorMessage)
                    ? (resp.errorMessage || resp.ErrorMessage)
                    : ('Failed to update ' + r.label);
                Toaster.error(msg);
                return;
            }
        }

        this.rows = this.rows.map(r => ({ ...r, initial: r.allow }));

        this.sortRowsForDisplay();

        Toaster.success('Permissions updated');
    }

    public back() {
        this.$router.push({ path: '/UserManagement' });
    }
}
